export default "__VITE_ASSET__Nz35UoUz__"